import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeedContentDto, FeedResponseDto } from '../models/feed.model';

@Injectable({
  providedIn: 'root'
})
export class FeedService {
  feedController = '/api/Feed';

  constructor(private _http: HttpClient) {}

  getFeed(): Observable<FeedResponseDto>
  {
    return this._http.get<FeedResponseDto>(`${this.feedController}/`);
  }
}
